var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTrustpilotStars452022 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 128 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#00B67A",
  d: "M24 0H0v24h24zm26 0H26v24h24zm26 0H52v24h24zm26 0H78v24h24z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCDCE6",
  d: "M128 0h-12v24h12z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#00B67A",
  d: "M116 0h-12v24h12z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m12 16.18 3.65-.93 1.53 4.7zm8.4-6.08h-6.42L12 4.05l-1.97 6.05H3.6l5.2 3.75-1.97 6.05 5.2-3.75 3.2-2.3zM38 16.18l3.65-.93 1.53 4.7zm8.4-6.08h-6.42L38 4.05l-1.97 6.05H29.6l5.2 3.75-1.97 6.05 5.2-3.75 3.2-2.3zM64 16.18l3.65-.93 1.53 4.7zm8.4-6.08h-6.42L64 4.05l-1.97 6.05H55.6l5.2 3.75-1.97 6.05 5.2-3.75 3.2-2.3zM90 16.18l3.65-.93 1.53 4.7zm8.4-6.08h-6.42L90 4.05l-1.97 6.05H81.6l5.2 3.75-1.97 6.05 5.2-3.75 3.2-2.3zm17.6 6.08 3.65-.93 1.52 4.7zm8.4-6.08h-6.43L116 4.05l-1.97 6.05h-6.43l5.2 3.75-1.97 6.05 5.2-3.75 3.2-2.3z"
})));
export { SvgTrustpilotStars452022 as ReactComponent };
export default new URL("/home/runner/_work/motorway-seller-webapp/motorway-seller-webapp/src/client/assets_seller/trustpilot/trustpilot-stars-4.5-2022.svg", import.meta.url).toString();